module.exports = __webpack_public_path__ + "static/media/night09.a1f8c907.jpg";